/* Aniva — quiz « bilan mobilité ». Généré depuis quiz_8.html ; la config
   (prix, plans, images, code promo) est injectée par la section Liquid dans
   window.ANIVA_QUIZ — ce fichier ne contient AUCUN prix en dur. */
var QZ=window.ANIVA_QUIZ||{img:[],video:"",price:{base:44.90,sub:32.90},firstPct:50,plans:{},variant:0,gift:0,discountUrl:"/checkout"};
QZ.cfg=QZ.cfg||{blocks:[],res:{}};
var R=QZ.cfg.res||{};
var state = { name:"", gender:"m", weight:null, age:null, signs:[], freq:null, since:null, activity:null, current:null, goals:[], email:"" };

function il(){ return state.gender==="f"?"elle":"il"; }
function Il(){ return state.gender==="f"?"Elle":"Il"; }
function dogName(){ return state.name ? state.name : (state.gender==="f"?"votre chienne":"votre chien"); }

var TICK='<svg viewBox="0 0 24 24" fill="none"><path d="M20 6L9 17l-5-5" stroke="#fff" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></svg>';
var CK='<svg viewBox="0 0 24 24" fill="none"><path d="M20 6L9 17l-5-5" stroke="#2f7d4f" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></svg>';

/* hand-drawn dog illustrations (Japhy style) — male = plain, female = + bow */
var DOG_BLOB='<path d="M70 15 C106 15 127 37 127 71 C127 107 104 127 70 127 C36 127 13 107 13 73 C13 37 34 15 70 15 Z" fill="#bcd6f2"/>';
var DOG_FACE='<g fill="#eef4fb" stroke="#24312c" stroke-width="3.4" stroke-linecap="round" stroke-linejoin="round">'+
  '<path d="M53 48 C38 43 26 54 28 73 C29 86 39 91 50 86 C48 74 49 60 53 48 Z"/>'+   /* left floppy ear */
  '<path d="M87 48 C102 43 114 54 112 73 C111 86 101 91 90 86 C92 74 91 60 87 48 Z"/>'+ /* right floppy ear */
  '<path d="M48 60 C48 47 58 41 70 41 C82 41 92 47 92 60 C92 78 85 94 70 94 C55 94 48 78 48 60 Z"/>'+ /* head */
  '</g>'+
  '<g fill="none" stroke="#24312c" stroke-width="3.4" stroke-linecap="round" stroke-linejoin="round">'+
  '<path d="M70 79 C70 85 64 87 60 84"/>'+  /* mouth left */
  '<path d="M70 79 C70 85 76 87 80 84"/>'+  /* mouth right */
  '</g>'+
  '<g fill="#24312c"><circle cx="61" cy="63" r="3.6"/><circle cx="79" cy="63" r="3.6"/>'+
  '<ellipse cx="70" cy="74" rx="5.4" ry="4.2"/></g>';
var DOG_BOW='<g stroke="#c85f79" stroke-width="2" stroke-linejoin="round">'+
  '<path d="M70 33 L55 26 L55 40 Z" fill="#ef8fa3"/>'+
  '<path d="M70 33 L85 26 L85 40 Z" fill="#ef8fa3"/>'+
  '<circle cx="70" cy="33" r="4.5" fill="#e97690"/></g>';
function dogSVG(extra){return '<svg viewBox="0 0 140 140" xmlns="http://www.w3.org/2000/svg">'+DOG_BLOB+DOG_FACE+(extra||'')+'</svg>';}
var DOG_M=dogSVG(''); var DOG_F=dogSVG(DOG_BOW);

var MARIE=QZ.img[0];
function teamTipHTML(t){
  return '<div class="teamtip"><p>'+t.text+'</p>'+
    '<div class="tt-who"><img class="tt-av" src="'+MARIE+'" alt="'+t.name+'"><b>'+t.name+'</b></div></div>';
}

var CLAIRE=QZ.img[1];
var ACTIVITY_IMG=QZ.img[2];
function vetCardHTML(v){
  return '<div class="vetcard">'+
    '<div class="vc-head"><img class="vc-av" src="'+CLAIRE+'" alt="'+v.name+'">'+
    '<div class="vc-name"><b>Le conseil de '+v.name+'</b><span>'+v.role+'</span></div></div>'+
    '<p class="vc-quote">'+v.quote+'</p></div>';
}

var ZOE_VIDEO=QZ.video;
function reviewCardHTML(r){
  return '<div class="review">'+
    (r.video?'<div class="review-media"><video src="'+ZOE_VIDEO+'" poster="'+QZ.img[3]+'" autoplay loop muted playsinline preload="metadata"></video><span class="ba left">AVANT</span><span class="ba right">APRÈS</span></div>':'')+
    '<div class="review-body">'+
      '<div class="rstars">'+Array((r.stars||5)+1).join("★")+'</div>'+
      '<h4>'+r.title+'</h4>'+
      '<p>'+r.quote+'</p>'+
      '<div class="rauthor">'+r.author+'</div>'+
    '</div></div>';
}

/* age-risk chart (brand-matched, editable SVG) */
var AGE_FIG = `<div class="figcard">
<svg viewBox="0 0 520 300" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Risque de troubles articulaires selon l'âge">
  <defs><linearGradient id="ag" x1="0" y1="0" x2="0" y2="1">
    <stop offset="0" stop-color="#2f5d4f" stop-opacity="0.24"/>
    <stop offset="1" stop-color="#2f5d4f" stop-opacity="0"/></linearGradient></defs>
  <line x1="52" y1="236" x2="498" y2="236" stroke="#e3ddd0" stroke-width="2"/>
  <path d="M52,232.4 L163.5,223.3 L275,190.3 L386.5,130.7 L498,40 L498,236 L52,236 Z" fill="url(#ag)"/>
  <path d="M52,232.4 L163.5,223.3 L275,190.3 L386.5,130.7 L498,40" fill="none" stroke="#2f5d4f" stroke-width="3" stroke-linejoin="round" stroke-linecap="round"/>
  <line x1="386.5" y1="34" x2="386.5" y2="236" stroke="#9aa79f" stroke-width="1.5" stroke-dasharray="4 4"/>
  <text x="379" y="24" text-anchor="end" font-family="sans-serif" font-size="11" font-weight="700" fill="#3f7a67">diagnostic médian : 10 ans et demi</text>
  <g stroke="#2f5d4f" stroke-width="3" fill="#fff">
    <circle cx="52" cy="232.4" r="4.5"/><circle cx="163.5" cy="223.3" r="4.5"/>
    <circle cx="275" cy="190.3" r="4.5"/><circle cx="386.5" cy="130.7" r="4.5"/>
    <circle cx="498" cy="40" r="5.5" fill="#2f5d4f"/></g>
  <g font-family="sans-serif" font-size="12.5" font-weight="800" fill="#2f5d4f">
    <text x="52" y="220" text-anchor="start">réf.</text>
    <text x="163.5" y="211" text-anchor="middle">×3,5</text>
    <text x="275" y="178" text-anchor="middle">×12,6</text>
    <text x="386.5" y="118" text-anchor="middle">×29</text>
    <text x="498" y="30" text-anchor="end">×54</text></g>
  <g font-family="sans-serif" font-size="11" font-weight="600" fill="#8a938b">
    <text x="52" y="255" text-anchor="start">moins de 3</text>
    <text x="163.5" y="255" text-anchor="middle">3-6 ans</text>
    <text x="275" y="255" text-anchor="middle">6-9 ans</text>
    <text x="386.5" y="255" text-anchor="middle">9-12 ans</text>
    <text x="498" y="255" text-anchor="end">12 ans et +</text></g>
</svg>
<div class="fig-cap"><b>Le risque grimpe vite avec l'âge.</b> Chez le chien, la fréquence des troubles articulaires diagnostiqués est déjà multipliée par 3,5 dès 3 ans… et par 54 après 12 ans. L'âge médian du diagnostic&nbsp;: 10 ans et demi.</div>
<div class="fig-src">455 557 chiens suivis en clientèle vétérinaire · fréquence de diagnostic comparée aux chiens de moins de 3 ans · Scientific Reports, 2018.</div>
</div>`;

/* milestone groups for the Japhy-style stepper */
var MILES = [
  {key:"Profil",  label:"Profil"},
  {key:"Observation", label:"Observation"},
  {key:"Mode de vie", label:"Mode de vie"},
  {key:"Objectif", label:"Objectif"},
  {key:"Programme", label:"Programme"}
];

/* Les écrans arrivent de la section (blocs, réordonnables dans l'éditeur).
   Ce fichier ne contient plus aucun texte : uniquement la mécanique. */
function optLines(txt){
  return (txt||"").split("\n").map(function(l){return l.trim();}).filter(Boolean).map(function(l){
    var p=l.split("|").map(function(x){return x.trim();});
    var o={v:p[0],e:p[1]||"",t:p[2]||"",s:p[3]||""};
    if(p[4]==="solo") o.solo=true;
    return o;
  });
}
function hl(t){ return (t||"").replace(/\[\[(.+?)\]\]/g,'<span class="hl">$1</span>'); }
var screens = (QZ.cfg.blocks||[]).map(function(bk){
  var s=bk.s||{};
  if(bk.type==="intro")  return { id:"intro", type:"intro", mile:"Profil", cfg:s };
  if(bk.type==="nom")    return { id:"name", type:"text", mile:"Profil", section:s.section,
    intro:{title:s.intro_title, badge:s.intro_badge, text:s.intro_text},
    q:s.q, sub:s.sub, placeholder:s.placeholder, key:"name" };
  if(bk.type==="question"){
    var sc={ id:s.key, type:s.multi?"multi":"single", mile:s.mile||"Profil", section:s.section,
      q:s.q, sub:s.sub, key:s.key, opts:optLines(s.opts) };
    if(s.layout_cards){ sc.layout="cards"; sc.opts.forEach(function(o){ o.art = o.v==="f" ? DOG_F : DOG_M; }); }
    if(s.key==="age") sc.figure=AGE_FIG;
    if(s.key==="current") sc.img=ACTIVITY_IMG;
    if(s.tip_text) sc.tip={name:s.tip_name,text:s.tip_text};
    if(s.rev_quote) sc.review={video:!!s.rev_video, stars:5, title:s.rev_title, quote:s.rev_quote, author:s.rev_author};
    return sc;
  }
  if(bk.type==="double") return { id:"freqsince", type:"observe2", mile:s.mile||"Observation", section:s.section,
    condition:function(){ return state.signs.length>0 && state.signs.indexOf("none")===-1; },
    q1:s.q1, key1:"freq", opts1:optLines(s.opts1),
    q2:s.q2, key2:"since", opts2:optLines(s.opts2),
    vet:{name:s.vet_name, role:s.vet_role, quote:s.vet_quote} };
  if(bk.type==="email")  return { id:"email", type:"email", mile:"Objectif", section:s.section,
    q:s.q, sub:s.sub, placeholder:s.placeholder, key:"email", optional:true };
  if(bk.type==="etape")  return { id:"build", type:"build", mile:"Programme", cfg:s };
  return null;
}).filter(Boolean);
screens.push({ id:"results", type:"results", mile:"Programme" });

var idx=0;
var stage=document.getElementById("stage");
var stepsEl=document.getElementById("steps");
var backBtn=document.getElementById("backBtn");
var topbar=document.getElementById("topbar");
var promo=document.getElementById("promo");
backBtn.onclick=goPrev;

function interpolate(str){
  if(!str) return "";
  return str.replace(/\{Name\}/g,state.name||"Votre chien")
            .replace(/\{name\}/g,dogName())
            .replace(/\{Il\}/g,Il()).replace(/\{il\}/g,il());
}

function renderSteps(cur){
  var curMileIdx = MILES.map(function(m){return m.key;}).indexOf(cur.mile);
  stepsEl.innerHTML = MILES.map(function(m,i){
    var cls = i<curMileIdx?"done":(i===curMileIdx?"cur":"");
    var inner = cls==="cur" ? '🐶' : '';
    return '<div class="st '+cls+'"><div class="lbl">'+m.label+'</div><div class="ind">'+inner+'</div></div>';
  }).join("");
}

function render(){
  var s=screens[idx];
  if(s.condition && !s.condition()){ idx++; return render(); }
  stage.innerHTML="";
  var hideChrome = (s.type==="build"||s.type==="results"||s.type==="intro");
  backBtn.classList.toggle("show", idx>0 && !hideChrome);
  stepsEl.style.display = (s.type==="build"||s.type==="results"||s.type==="intro") ? "none":"flex";
  promo.style.display = (s.type==="build") ? "none":"block";
  renderSteps(s);

  if(s.type==="intro") return renderIntro();
  if(s.type==="text"||s.type==="email") return renderText(s);
  if(s.type==="single") return renderSingle(s);
  if(s.type==="multi") return renderMulti(s);
  if(s.type==="observe2") return renderObserve2(s);
  if(s.type==="build") return renderBuild();
  if(s.type==="results") return renderResults();
}
function wrap(html,cls){var d=document.createElement("div");d.className="screen "+(cls||"");d.innerHTML=html;stage.appendChild(d);return d;}

function goNext(){ idx++; if(idx>=screens.length) idx=screens.length-1; render(); scrollTop(); }
function goPrev(){ if(idx>0){ idx--; var s=screens[idx]; if(s.condition && !s.condition()) return goPrev(); render(); scrollTop(); } }
function scrollTop(){ window.scrollTo(0,0); if(stage) stage.scrollTop=0; }

/* INTRO */
/* témoignages : fournis par le bloc intro (une ligne = citation|émoji|nom|chien) */

function renderIntro(){
  var c=screens[idx].cfg||{};
  var tcards = optLines(c.avis).map(function(t){
    return '<div class="tcard"><div class="ts">'+"★★★★★"+'</div>'+
      '<p>« '+t.v+' »</p>'+
      '<div class="who"><div class="av">'+t.e+'</div><div><b>'+t.t+'</b><span>'+t.s+'</span></div>'+
      (c.verif?'<div class="verif">'+c.verif+'</div>':'')+'</div></div>';
  }).join("");
  var feats = optLines(c.piliers).map(function(f){
    return '<div><span class="fi">'+f.v+'</span><span class="ft">'+f.e.replace(/\s*\/\s*/g,"<br>")+'</span></div>';
  }).join("");
  var metas = optLines(c.chiffres).map(function(m){
    return '<div><b>'+m.v+'</b><span>'+m.e+'</span></div>';
  }).join("");
  var el=wrap(
    '<div class="hero">'+
      '<img class="hero-img" src="'+QZ.img[4]+'" alt="Un maître et son chien">'+
      '<div class="hero-grad"></div>'+
      '<div class="hero-badge2"><span class="dot"></span> '+(c.badge||"")+'</div>'+
    '</div>'+
    '<div class="lp">'+
      (c.etoiles?'<div class="stars-row"><span class="s">★★★★★</span><span class="r">'+c.etoiles+'</span></div>':'')+
      '<h1>'+hl(c.titre)+'</h1>'+
      '<p class="sub">'+(c.sous_titre||"")+'</p>'+
      '<button class="cta-lp" id="startBtn">'+(c.cta||"Commencer")+'</button>'+
      '<div class="microtrust">'+(c.micro||"")+'</div>'+
      (feats?'<div class="feat">'+feats+'</div>':'')+
      (metas?'<div class="rowmeta">'+metas+'</div>':'')+
      (tcards?'<div class="tsec">'+
        '<div class="tsec-h">'+(c.avis_titre||"")+'</div>'+
        '<p class="tsec-sub">'+(c.avis_sous_titre||"")+'</p>'+
        '<div class="trow">'+tcards+'</div>'+
      '</div>':'')+
      '<div class="lp-final"><button class="cta-lp" id="startBtn2">'+(c.cta||"Commencer")+'</button>'+
      '<div class="microtrust">'+(c.micro2||c.micro||"")+'</div></div>'+
    '</div>');
  el.querySelector("#startBtn").onclick=goNext;
  el.querySelector("#startBtn2").onclick=goNext;
}

/* TEXT / EMAIL */
function renderText(s){
  var val=state[s.key]||"";
  var el=wrap(
    (s.intro?'<div class="infocard"><div class="ic-top"><h4>'+s.intro.title+'</h4><span class="badge">'+s.intro.badge+'</span></div><p>'+s.intro.text+'</p></div>':'')+
    '<div class="eyebrow">'+(s.section||"")+'</div>'+
    '<h1>'+interpolate(s.q)+'</h1>'+
    (s.sub?'<p class="sub">'+interpolate(s.sub)+'</p>':'')+
    '<div class="field"><input id="inp" type="'+(s.type==="email"?"email":"text")+'" inputmode="'+(s.type==="email"?"email":"text")+'" placeholder="'+s.placeholder+'" value="'+val.replace(/"/g,"&quot;")+'" autocomplete="'+(s.type==="email"?"email":"off")+'"></div>'+
    (s.id==="name"?'<img class="trust-shot" src="'+QZ.img[5]+'" alt="Approuvé par les vétérinaires">':'')+
    '<div class="foot"><button class="btn" id="nextBtn"'+((s.type==="text"&&!val)?" disabled":"")+'>'+
      (s.optional?"Voir le programme de "+(state.name||"mon chien"):"Continuer")+'</button>'+
      (s.optional?'<div class="microtrust">On respecte votre boîte mail.</div>':'')+'</div>');
  var inp=el.querySelector("#inp"),btn=el.querySelector("#nextBtn");
  setTimeout(function(){inp.focus();},100);
  inp.oninput=function(){ state[s.key]=inp.value.trim(); if(s.type==="text"&&!s.optional) btn.disabled=inp.value.trim().length<1; };
  inp.onkeydown=function(e){ if(e.key==="Enter"&&!btn.disabled) btn.click(); };
  btn.onclick=function(){ state[s.key]=inp.value.trim(); goNext(); };
}

/* CARDS (illustrated single-choice) */
function renderCards(s){
  var el=wrap(
    '<div class="eyebrow">'+(s.section||"")+'</div>'+
    '<h1>'+interpolate(s.q)+'</h1>'+
    (s.sub?'<p class="sub">'+interpolate(s.sub)+'</p>':'')+
    '<div class="cardgrid" id="cg"></div>');
  var wp=el.querySelector("#cg");
  s.opts.forEach(function(o){
    var b=document.createElement("button");
    b.className="qcard"+(state[s.key]===o.v?" sel":"");
    b.innerHTML='<span class="tickc">'+TICK+'</span><span class="art">'+o.art+'</span><span class="lbl">'+interpolate(o.t)+'</span>';
    b.onclick=function(){ state[s.key]=o.v; Array.prototype.forEach.call(wp.children,function(c){c.classList.remove("sel");}); b.classList.add("sel"); setTimeout(goNext,240); };
    wp.appendChild(b);
  });
}

/* option button helper */
function optButton(o){
  var b=document.createElement("button");
  b.className="opt";
  b.innerHTML='<span class="emoji">'+o.e+'</span><span class="txt">'+interpolate(o.t)+(o.s?'<small>'+interpolate(o.s)+'</small>':'')+'</span><span class="tick">'+TICK+'</span>';
  return b;
}

/* OBSERVE2 — question 1 is REPLACED by question 2 once answered (same page) */
function renderObserve2(s){
  var el=wrap(
    '<div class="eyebrow">'+(s.section||"")+'</div>'+
    '<div id="step1" class="reveal-block">'+
      '<h1>'+interpolate(s.q1)+'</h1>'+
      '<div class="opts" id="opts1"></div>'+
    '</div>'+
    '<div id="step2" class="reveal-block" style="display:none">'+
      '<h1>'+interpolate(s.q2)+'</h1>'+
      '<div class="opts" id="opts2"></div>'+
    '</div>'+
    (s.vet?vetCardHTML(s.vet):''));
  var step1=el.querySelector("#step1"),step2=el.querySelector("#step2");
  var opts1=el.querySelector("#opts1"),opts2=el.querySelector("#opts2");
  function showStep2(animate){
    step1.style.display="none";
    step2.style.display="block";
    if(animate){ step2.classList.remove("revealed"); void step2.offsetWidth; step2.classList.add("revealed"); }
  }
  s.opts1.forEach(function(o){
    var b=optButton(o);
    if(state[s.key1]===o.v) b.classList.add("sel");
    b.onclick=function(){
      state[s.key1]=o.v;
      Array.prototype.forEach.call(opts1.children,function(c){c.classList.remove("sel");});
      b.classList.add("sel");
      setTimeout(function(){ showStep2(true); }, 240);
    };
    opts1.appendChild(b);
  });
  s.opts2.forEach(function(o){
    var b=optButton(o);
    if(state[s.key2]===o.v) b.classList.add("sel");
    b.onclick=function(){
      state[s.key2]=o.v;
      Array.prototype.forEach.call(opts2.children,function(c){c.classList.remove("sel");});
      b.classList.add("sel");
      setTimeout(goNext, 240); /* auto-advance, no Continue button */
    };
    opts2.appendChild(b);
  });
  if(state[s.key1]) showStep2(false); /* returning: already past freq -> show step 2 */
}

/* SINGLE */
function renderSingle(s){
  if(s.layout==="cards") return renderCards(s);
  var el=wrap(
    '<div class="eyebrow">'+(s.section||"")+'</div>'+
    '<h1>'+interpolate(s.q)+'</h1>'+
    (s.sub?'<p class="sub">'+interpolate(s.sub)+'</p>':'')+
    '<div class="opts" id="opts"></div>'+
    (s.tip?teamTipHTML(s.tip):'')+
    (s.vet?vetCardHTML(s.vet):'')+
    (s.img?'<img class="trust-shot" src="'+s.img+'" alt="">':'')+
    (s.figure?s.figure:''));
  var wp=el.querySelector("#opts");
  s.opts.forEach(function(o){
    var b=document.createElement("button");
    b.className="opt"+(state[s.key]===o.v?" sel":"");
    b.innerHTML='<span class="emoji">'+o.e+'</span><span class="txt">'+interpolate(o.t)+(o.s?'<small>'+interpolate(o.s)+'</small>':'')+'</span><span class="tick">'+TICK+'</span>';
    b.onclick=function(){ state[s.key]=o.v; Array.prototype.forEach.call(wp.children,function(c){c.classList.remove("sel");}); b.classList.add("sel"); setTimeout(goNext,220); };
    wp.appendChild(b);
  });
}

/* MULTI */
function renderMulti(s){
  var el=wrap(
    '<div class="eyebrow">'+(s.section||"")+'</div>'+
    '<h1>'+interpolate(s.q)+'</h1>'+
    (s.sub?'<p class="sub">'+interpolate(s.sub)+'</p>':'')+
    '<div class="opts" id="opts"></div>'+
    (s.review?reviewCardHTML(s.review):'')+
    '<div class="foot"><button class="btn" id="nextBtn"'+(state[s.key].length?"":" disabled")+'>Continuer</button></div>');
  var wp=el.querySelector("#opts"),btn=el.querySelector("#nextBtn");
  var buttons=[];
  function refresh(){
    buttons.forEach(function(item){ item.b.classList.toggle("sel", state[s.key].indexOf(item.v)>-1); });
    btn.disabled=state[s.key].length===0;
  }
  s.opts.forEach(function(o){
    var b=document.createElement("button");
    b.className="opt"+(state[s.key].indexOf(o.v)>-1?" sel":"");
    b.innerHTML='<span class="emoji">'+o.e+'</span><span class="txt">'+interpolate(o.t)+(o.s?'<small>'+interpolate(o.s)+'</small>':'')+'</span><span class="tick">'+TICK+'</span>';
    b.onclick=function(){
      var arr=state[s.key];
      if(o.solo){ state[s.key]=(arr.indexOf(o.v)>-1)?[]:[o.v]; }
      else{
        var solos=s.opts.filter(function(x){return x.solo;}).map(function(x){return x.v;});
        arr=arr.filter(function(v){return solos.indexOf(v)===-1;});
        var i=arr.indexOf(o.v); if(i>-1)arr.splice(i,1); else arr.push(o.v);
        state[s.key]=arr;
      }
      refresh();
    };
    buttons.push({b:b,v:o.v});
    wp.appendChild(b);
  });
  btn.disabled=state[s.key].length===0;
  btn.onclick=goNext;
}

/* BUILD */
function renderBuild(){ sendEmailLead();
  var c=screens[idx].cfg||{};
  var steps=(c.etapes||"").split("\n").map(function(l){return l.trim();}).filter(Boolean)
    .map(function(t){return interpolate(t);});
  var items=steps.map(function(t){return '<div class="cl-item"><span class="cbox">'+TICK+'</span>'+t+'</div>';}).join("");
  var el=wrap('<div class="build" style="flex:1;display:flex;flex-direction:column;justify-content:center"><div class="spinner"></div><h2>'+interpolate(c.titre||"On prépare le programme de {name}…")+'</h2><div class="checklist">'+items+'</div></div>',"build");
  var cl=el.querySelectorAll(".cl-item"),i=0;
  var iv=setInterval(function(){
    if(i<cl.length){ cl[i].classList.add("on"); i++; }
    else{ clearInterval(iv); setTimeout(goNext,650); }
  },700);
}

/* ---------- PLAN LOGIC ---------- */
function computePlan(){
  var w=state.weight;
  /* Tranches ALIGNÉES SUR L'ÉTIQUETTE (120 friandises par pot) :
     1/2/3/4 friandises par jour → un pot dure 120/60/40/30 jours.
     Le rythme choisit un plan de vente EXISTANT (1, 2 ou 3 mois), avec
     toujours un peu d'avance — même logique que la fiche produit. */
  var dose,potWeeks,perMonth,gab,units,months;
  if(w==="xs"){ dose="1 friandise par jour"; potWeeks=17; perMonth=1; gab="petit gabarit"; units=1; months=3; }
  else if(w==="s"){ dose="2 friandises par jour"; potWeeks=8; perMonth=1; gab="gabarit moyen"; units=2; months=3; }
  else if(w==="m"){ dose="3 friandises par jour"; potWeeks=5; perMonth=1; gab="grand chien"; units=2; months=2; }
  else { dose="4 friandises par jour"; potWeeks=4; perMonth=2; gab="très grand gabarit"; units=3; months=2; }

  // tier
  var hasSigns = state.signs.length>0 && state.signs.indexOf("none")===-1;
  var older = (state.age==="mature"||state.age==="senior");
  var intense = hasSigns && (state.freq==="daily" || state.since==="year" || state.age==="senior");
  var tier, tierDesc, cure;
  if(!hasSigns){
    tier=R.t_prev_nom; tierDesc=R.t_prev_desc; cure=R.t_prev_cure;
  } else if(intense){
    tier=R.t_int_nom; tierDesc=R.t_int_desc; cure=R.t_int_cure;
  } else {
    tier=R.t_conf_nom; tierDesc=R.t_conf_desc; cure=R.t_conf_cure;
  }

  var deliveryTxt = units+" pot"+(units>1?"s":"")+" tous les "+(months>1?months+" mois":"mois");
  if(units===1&&months===1) deliveryTxt="1 pot chaque mois";
  // prix : lus dans Shopify via la config — plus jamais de chiffres en dur
  var oneTime=QZ.price.base;
  var subUnit=QZ.price.sub;
  return {dose:dose,potWeeks:potWeeks,perMonth:perMonth,gab:gab,tier:tier,tierDesc:tierDesc,cure:cure,delivery:deliveryTxt,oneTime:oneTime,subUnit:subUnit,units:units,months:months,hasSigns:hasSigns,older:older};
}

var SIGN_LABELS={stairs:"escaliers difficiles",getup:"se lève lentement",stiff:"raideur au réveil",play:"joue moins",limp:"boiterie occasionnelle",jump:"n'ose plus sauter"};
var ACT_LABELS={athlete:"grand sportif",active:"actif",calm:"tranquille",rest:"repos"};

function buildReason(p){
  var n=state.name||"votre chien";
  var bits=[];
  if(p.hasSigns){
    var s=state.signs.filter(function(v){return v!=="none";}).map(function(v){return SIGN_LABELS[v];});
    if(s.length){ bits.push("Vous avez remarqué que "+dogName()+" a des signes de gêne ("+s.slice(0,3).join(", ")+")"); }
  } else {
    bits.push("Vous voulez avant tout protéger les articulations de "+dogName()+" et anticiper");
  }
  if(state.age==="senior") bits.push("À son âge, un soutien articulaire régulier fait une vraie différence sur le confort");
  else if(state.age==="mature") bits.push("C'est justement l'âge idéal pour soutenir ses articulations avant que la gêne ne s'installe");
  if(state.weight==="m"||state.weight==="l") bits.push("Son gabarit sollicite davantage ses articulations, le dosage est ajusté en conséquence");
  if(state.activity==="athlete") bits.push("Son activité intense demande une récupération articulaire à la hauteur");
  return bits.slice(0,3).join(". ")+".";
}

/* RESULTS */
function renderResults(){
  var p=computePlan();
  var n=state.name||"votre chien";
  var signChips = state.signs.filter(function(v){return v!=="none";}).map(function(v){return '<span class="chip">'+SIGN_LABELS[v]+'</span>';}).join("");
  if(!signChips) signChips='<span class="chip">prévention</span>';
  var savePct = Math.round((1-(p.subUnit/p.oneTime))*100);
  var firstOrder = (QZ.firstPct>0 ? p.oneTime*p.units*(1-QZ.firstPct/100) : p.subUnit*p.units).toFixed(2).replace(".",","); /* firstPct 0 = pas de remise 1ʳᵉ commande : on affiche le vrai prix abo */
  var recurring = (p.subUnit*p.units).toFixed(2).replace(".",",");
  var oldRecurring = (p.oneTime*p.units).toFixed(2).replace(".",",");
  var V={pct:QZ.firstPct, prix:p.oneTime.toFixed(2).replace(".",","), pot:p.subUnit.toFixed(2).replace(".",","), eco:savePct, dose:p.dose, gab:p.gab, cure:p.cure, livraison:p.delivery};
  function T(t){ return interpolate((t||"")).replace(/\{(pct|prix|pot|eco|dose|gab|cure|livraison)\}/g,function(_,k){return V[k];}); }
  var incl=(R.incl||"").split("\n").map(function(l){return l.trim();}).filter(Boolean)
    .map(function(l){return '<li><span class="ck">'+CK+'</span> '+T(l)+'</li>';}).join("");
  var el=wrap(
    '<div class="res-hero"><span class="pawbg">🐾</span>'+
      '<div class="k">'+T(R.k)+'</div>'+
      '<h2>'+p.tier+'</h2>'+
      '<p>'+p.tierDesc+'</p>'+
      '<div class="tier">'+T(R.badge)+'</div>'+
    '</div>'+
    '<div class="card"><h3>'+T(R.recap_h)+'</h3>'+
      '<div class="signs-recap">'+signChips+'</div>'+
      '<p style="margin:14px 0 0;font-size:14.5px;color:var(--ink)">'+buildReason(p)+'</p>'+
    '</div>'+
    '<div class="card"><h3>'+T(R.cure_h)+'</h3>'+
      '<div class="plan-line"><span class="ic">⚖️</span><div><b>'+T(R.l1_t)+'</b><span>'+T(R.l1_s)+'</span></div></div>'+
      '<div class="plan-line"><span class="ic">📆</span><div><b>{cure}</b><span>'.replace("{cure}",V.cure)+T(R.l2_s)+'</span></div></div>'+
      '<div class="plan-line"><span class="ic">🚚</span><div><b>'+T(R.l3_t)+'</b><span>'+T(R.l3_s)+'</span></div></div>'+
      '<div class="plan-line"><span class="ic">🌿</span><div><b>'+T(R.l4_t)+'</b><span>'+T(R.l4_s)+'</span></div></div>'+
    '</div>'+
    '<div class="offer"><span class="flag">'+T(R.flag)+'</span>'+
      '<h3>'+T(R.offer_h)+'</h3>'+
      '<div class="freq">'+V.livraison+' · '+T(R.freq_suffixe)+'</div>'+
      '<div class="price"><span class="now">'+firstOrder+' €</span><span class="old">'+oldRecurring+' €</span></div>'+
      '<div class="price" style="margin-top:2px"><span class="unit">puis '+recurring+' € par livraison ('+T(R.unit_ligne)+')</span></div>'+
      '<span class="save">'+T(R.eco_ligne)+'</span>'+
      '<ul class="incl">'+incl+'</ul>'+
      '<div class="foot" style="padding-top:16px"><button class="btn green" id="cta">'+T(R.cta)+'</button></div>'+
      '<div class="alt"><button id="oneTimeBtn">'+T(R.onetime)+'</button></div>'+
    '</div>'+
    '<div class="guarantee"><span class="g-ic">🛡️</span><p>'+T(R.g_titre)+'<span>'+T(R.g_texte)+'</span></p></div>'+
    '<div class="fam"><h3 class="fam-h">'+T(R.fam_h)+'</h3>'+
    '<p class="fam-sub">'+T(R.fam_sub)+'</p>'+
    '<img class="fam-collage" src="'+QZ.img[6]+'" alt="La famille Aniva"></div>'+
    '<div class="legal">'+T(R.legal)+'</div>'
  ,"");
  el.querySelector("#cta").onclick=function(){ startCheckout(p,true,this); };
  el.querySelector("#oneTimeBtn").onclick=function(){ startCheckout(p,false,this); };
}

render();
/* ---------- branchements boutique ---------- */
function sendEmailLead(){
  var e=state.email;
  if(!e||!/.+@.+\..+/.test(e)||window.__aqLead) return;
  window.__aqLead=1;
  var fd=new FormData();
  fd.append("form_type","customer"); fd.append("utf8","✓");
  fd.append("contact[email]",e); fd.append("contact[tags]","quiz-bilan,newsletter");
  fetch("/contact",{method:"POST",body:fd}).catch(function(){});
}
function startCheckout(p,abo,btn){
  var items=[{id:QZ.variant,quantity:p.units}];
  if(abo){
    if(QZ.plans[p.months]) items[0].selling_plan=QZ.plans[p.months];
    if(QZ.gift) items.push({id:QZ.gift,quantity:1});
  }
  var avant=btn?btn.textContent:"";
  if(btn){btn.disabled=true;btn.textContent="Un instant…";}
  fetch("/cart/add.js",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({items:items})})
    .then(function(r){ if(!r.ok) throw 0; return r.json(); })
    .then(function(){ window.location.href = abo && QZ.discountUrl ? QZ.discountUrl : "/checkout"; })
    .catch(function(){ if(btn){btn.disabled=false;btn.textContent=avant||"Réessayer";} });
}
